import { useState } from "react";
import { CrearEntidadForm, Input, Select } from "@/components/ui";
import { toastError } from "@/lib/toast";
import type { CuentaContable } from "@/lib/types";
import { useCrearClaveSatClaveCuenta } from "../hooks/use-clave-sat-clave-cuenta-mutations";

/**
 * Alta de un mapeo · clave SAT + cuenta contable obligatorias, nombre
 * opcional (etiqueta descriptiva del mapeo, equivalente de dbo.Tag).
 */
export function ClaveSatClaveCuentaCrearForm({
  cuentas,
  onSalir,
  claveSatInicial = "",
}: {
  cuentas: CuentaContable[];
  onSalir: () => void;
  /** Prellenado (p. ej. desde una solicitud de cuenta del solicitante). */
  claveSatInicial?: string;
}) {
  const [claveSat, setClaveSat] = useState(claveSatInicial.toUpperCase());
  const [cuentaContableId, setCuentaContableId] = useState("");
  const [nombre, setNombre] = useState("");

  const crear = useCrearClaveSatClaveCuenta({ onCreado: onSalir });

  const submit = () => {
    if (!claveSat.trim() || !cuentaContableId) {
      toastError({ title: "Datos incompletos", message: "Clave SAT y cuenta contable son obligatorias." });
      return;
    }
    crear.mutate({ claveSat: claveSat.trim(), cuentaContableId, nombre: nombre.trim() });
  };

  return (
    <CrearEntidadForm
      titulo="Nueva cuenta por clave"
      descripcion="Relaciona una clave producto/servicio del SAT con la cuenta contable que derivará el prorrateo."
      cols={3}
      onCancelar={onSalir}
      onCrear={submit}
      creando={crear.isPending}
    >
      <Input label="Clave SAT" placeholder="01010101" value={claveSat} onChange={(e) => setClaveSat(e.currentTarget.value.toUpperCase())} maxLength={20} className="font-mono" required />
      <Select
        label="Cuenta contable"
        placeholder="Selecciona una cuenta…"
        options={cuentas.map((c) => ({ value: c.id, label: `${c.codigo} · ${c.nombre}` }))}
        value={cuentaContableId}
        onValueChange={setCuentaContableId}
        searchable
        searchPlaceholder="Buscar por código o nombre…"
        required
      />
      <Input label="Nombre (opcional)" placeholder="Papelería y útiles" value={nombre} onChange={(e) => setNombre(e.currentTarget.value)} maxLength={150} />
    </CrearEntidadForm>
  );
}
